<template>
	<div
		v-tooltip.bottom="{ content: 'Generate cover letter' }"
		class="flex space-x-2"
	>
		<div
			id="onboarding-cover-letter-reset-generation"
			data-step="4"
			:class="[
				'won-tag-light-gray size-6 rounded-md',
				'flex cursor-pointer items-center justify-center select-none',
			]"
		>

			<svg
				class="won-color-gray size-4 stroke-2"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0_1670_65851)">
					<path
						d="M11.6667 1.66699H5.00004C4.08337 1.66699 3.34171 2.41699 3.34171 3.33366L3.33337 16.667C3.33337 17.5837 4.07504 18.3337 4.99171 18.3337H15C15.9167 18.3337 16.6667 17.5837 16.6667 16.667V6.66699L11.6667 1.66699ZM10 15.0003C8.29171 15.0003 6.82504 13.967 6.18337 12.5003H7.60837C8.13337 13.2503 9.00837 13.7503 10 13.7503C11.6084 13.7503 12.9167 12.442 12.9167 10.8337C12.9167 9.22533 11.6084 7.91699 10 7.91699C8.87504 7.91699 7.90004 8.56699 7.41671 9.50033L8.75004 10.8337H5.41671V7.50033L6.50004 8.58366C7.24171 7.43366 8.52504 6.66699 10 6.66699C12.3 6.66699 14.1667 8.53366 14.1667 10.8337C14.1667 13.1337 12.3 15.0003 10 15.0003Z"
						fill="#444C58"
					/>
				</g>
				<defs>
					<clipPath id="clip0_1670_65851">
						<rect
							width="20"
							height="20"
							fill="white"
						/>
					</clipPath>
				</defs>
			</svg>
		</div>
	</div>
</template>
  